export default function msgWarn(message) {

    this.$toast.add({
        severity: "warn",
        summary: "Atenção.",
        detail: message,
        life: 6000,
    });
}